/**
 * Copyright (c) 2026-present, NDLA.
 *
 * This source code is licensed under the GPLv3 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

// N.B! AUTOGENERATED FILE. DO NOT EDIT
// Source: RemixIcon
// License: Apache License 2.0
import type { JSX } from "react";
import { Icon, type Props } from "../Icon";
export const Thumb = (props: Props): JSX.Element => (
  <Icon fill="currentColor" viewBox="0 0 24 24" {...props}>
    <path d="M14.6 8H21a2 2 0 0 1 2 2v2.1a2 2 0 0 1-.15.77l-3.1 7.51a1 1 0 0 1-.92.62H2a1 1 0 0 1-1-1V10a1 1 0 0 1 1-1h3.48a1 1 0 0 0 .82-.42L11.75.85a.5.5 0 0 1 .63-.16l1.82.91a2.5 2.5 0 0 1 1.3 2.85zM7 10.59V19h11.16L21 12.1V10h-6.4a2 2 0 0 1-1.94-2.5l.9-3.54a.5.5 0 0 0-.26-.57l-.66-.33-4.7 6.67a3 3 0 0 1-.94.86M5 11H3v8h2z" />
  </Icon>
);
